export const CONSTANT : string = "Constant";

export class Constant {
    static readonly DELETION_CONFERMATION_MESSAGE: string = "Are you sure you want to delete the selected files/folders/?";
    static readonly DOWNLOAD_NAME_TITLE: string = "How would you name your download?";
    static readonly RENAME_NAME_TITLE: string = "How would you rename your file/folder?";
    static readonly CREATE_FOLDER_TITLE: string = "How would you name your new folder?";
    static readonly TOAST_SELECT_BEFORE_ACTION: string = "You should select something before";
    static readonly TOAST_ERROR_RENAME: string = "You should select one file/folder to rename";
    static readonly DATE_FORMAT :string = "DDMMYYYY";
    static readonly ZIP_FORMAT :string = ".zip";
    static readonly YES :string = "Yes";
    static readonly NO :string = "No";
    static readonly DOWNLOAD :string = "Download";
    static readonly RENAME :string = "Rename";
    static readonly CANCEL :string = "Cancel";
    static readonly OK :string = "Ok";
    static readonly CAPSULE :string = "Capsule";
    static readonly NEW_FOLDER :string = "New capsule folder ";
    static readonly SUCCESS :string = "Success";
    static readonly $SUCCESS :string = "";
    static readonly DOWNLOAD_ABORTED :string = "Download aborted";
    static readonly RENAMING_ABORTED :string = "Renaming aborted";
    static readonly DOWNLOAD_COMPLETED :string = "Download completed";
    static readonly DOWNLOAD_STARTED :string = "Download started";
    static readonly FOLDER_CREATION_ABORTED :string = "Folder creation aborted";
    static readonly DELETION_ABORTED :string = "Deletion aborted";
}


// WEBPACK FOOTER //
// ./app/common/utils/constants.ts